import React from "react";
import { TextField, Button, Autocomplete, DialogActions } from "@mui/material";
import { useFormik } from "formik";
import { validationSchemaCar } from "./ValidationSchema";
import {
  inventoryTypes,
  fuelTypes,
  registrationTypes,
  transmissionTypes,
} from "./inventoryDropdown";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";

var customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

const AddCars = (props) => {
  const { Values, handleSubmit } = props;
  const formik = useFormik({
    initialValues: {
      name: Values.name,
      model: Values.model,
      registrationType: Values.registrationType,
      ownerSerial: Values.ownerSerial,
      yearOfManufacture:
        Values.yearOfManufacture === "" ? null : Values.yearOfManufacture,
      variant: Values.variant,
      color: Values.color,
      fuelType: Values.fuelType,
      insuranceExpiryDate:
        Values.insuranceExpiryDate === "" ? null : Values.insuranceExpiryDate,
      registrationExpiryDate:
        Values.registrationExpiryDate === ""
          ? null
          : Values.registrationExpiryDate,
      registrationDate:
        Values.registrationDate === "" ? null : Values.registrationDate,
      kmsDriven: Values.kmsDriven,
      price: Values.price,
      chassisNumber: Values.chassisNumber,
      inventoryType: Values.inventoryType,
      engineNumber: Values.engineNumber,
      vehicleNumber: Values.vehicleNumber,
      transmission: Values.transmission,
    },
    validationSchema: validationSchemaCar,
    onSubmit: (values) => {
      // update Values state with formik values
      for (const key in values) {
        Values[key] = values[key];
      }
      // call handleSubmit function from parent component
      handleSubmit();
    },
  });

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="grid grid-cols-2 gap-4 mb-4 p-2 items-end">
          <TextField
            type="text"
            fullWidth
            id="name"
            label="Make"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
          />
          <TextField
            type="text"
            fullWidth
            id="model"
            label="Model"
            value={formik.values.model}
            onChange={formik.handleChange}
            error={formik.touched.model && Boolean(formik.errors.model)}
            helperText={formik.touched.model && formik.errors.model}
          />
          <Autocomplete
            id="registrationType"
            options={registrationTypes}
            getOptionLabel={(option) => option}
            onChange={(event, value) => {
              formik.setFieldValue("registrationType", value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Registration Type"
                error={
                  formik.touched.registrationType &&
                  Boolean(formik.errors.registrationType)
                }
                helperText={
                  formik.touched.registrationType &&
                  formik.errors.registrationType
                }
              />
            )}
          />
          {/* <TextField
            type="text"
            fullWidth
            id="registrationType"
            label="Registration Type"
            value={formik.values.registrationType}
            onChange={formik.handleChange}
            error={
              formik.touched.registrationType &&
              Boolean(formik.errors.registrationType)
            }
            helperText={
              formik.touched.registrationType && formik.errors.registrationType
            }
          /> */}
          <TextField
            type="text"
            fullWidth
            id="ownerSerial"
            label="Owner Serial"
            value={formik.values.ownerSerial}
            onChange={formik.handleChange}
            error={
              formik.touched.ownerSerial && Boolean(formik.errors.ownerSerial)
            }
            helperText={formik.touched.ownerSerial && formik.errors.ownerSerial}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                views={["year", "month"]}
                format="MM/YYYY"
                label="Year Of Manufacture"
                value={formik.values.yearOfManufacture}
                onChange={(value) => {
                  if (value === null) return;
                  formik.setFieldValue("yearOfManufacture", value.format("MM/YYYY"));
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error:
                      formik.touched.yearOfManufacture &&
                      Boolean(formik.errors.yearOfManufacture),
                    helperText:
                      formik.touched.yearOfManufacture &&
                      formik.errors.yearOfManufacture,
                  },
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          {/* <TextField
            type="text"
            fullWidth
            id="yearOfManufacture"
            label="Year Of Manufacture"
            value={formik.values.yearOfManufacture}
            onChange={formik.handleChange}
            error={
              formik.touched.yearOfManufacture &&
              Boolean(formik.errors.yearOfManufacture)
            }
            helperText={
              formik.touched.yearOfManufacture &&
              formik.errors.yearOfManufacture
            }
          /> */}
          <TextField
            type="text"
            fullWidth
            id="variant"
            label="Variant"
            value={formik.values.variant}
            onChange={formik.handleChange}
            error={formik.touched.variant && Boolean(formik.errors.variant)}
            helperText={formik.touched.variant && formik.errors.variant}
          />
          <TextField
            type="text"
            fullWidth
            id="color"
            label="Color"
            value={formik.values.color}
            onChange={formik.handleChange}
            error={formik.touched.color && Boolean(formik.errors.color)}
            helperText={formik.touched.color && formik.errors.color}
          />
          <Autocomplete
            id="fuelType"
            options={fuelTypes}
            getOptionLabel={(option) => option}
            onChange={(event, value) => {
              formik.setFieldValue("fuelType", value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Fuel Type"
                error={
                  formik.touched.fuelType && Boolean(formik.errors.fuelType)
                }
                helperText={formik.touched.fuelType && formik.errors.fuelType}
              />
            )}
          />
          <Autocomplete
            id="transmission"
            options={transmissionTypes}
            getOptionLabel={(option) => option}
            onChange={(event, value) => {
              formik.setFieldValue("transmission", value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Transmission"
                error={
                  formik.touched.transmission &&
                  Boolean(formik.errors.transmission)
                }
                helperText={
                  formik.touched.transmission && formik.errors.transmission
                }
              />
            )}
          />
          <TextField
            type="text"
            fullWidth
            id="kmsDriven"
            label="Kilometres Driven"
            value={formik.values.kmsDriven}
            onChange={formik.handleChange}
            error={formik.touched.kmsDriven && Boolean(formik.errors.kmsDriven)}
            helperText={formik.touched.kmsDriven && formik.errors.kmsDriven}
          />

          <TextField
            type="text"
            fullWidth
            id="price"
            label="Price"
            value={formik.values.price}
            onChange={formik.handleChange}
            error={formik.touched.price && Boolean(formik.errors.price)}
            helperText={formik.touched.price && formik.errors.price}
          />
          <TextField
            type="text"
            fullWidth
            id="chassisNumber"
            label="Chassis Number"
            value={formik.values.chassisNumber}
            onChange={formik.handleChange}
            error={
              formik.touched.chassisNumber &&
              Boolean(formik.errors.chassisNumber)
            }
            helperText={
              formik.touched.chassisNumber && formik.errors.chassisNumber
            }
          />
          <Autocomplete
            id="inventoryType"
            options={inventoryTypes}
            getOptionLabel={(option) => option}
            onChange={(event, value) => {
              formik.setFieldValue("inventoryType", value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Inventory Type"
                error={
                  formik.touched.inventoryType &&
                  Boolean(formik.errors.inventoryType)
                }
                helperText={
                  formik.touched.inventoryType && formik.errors.inventoryType
                }
              />
            )}
          />
          <TextField
            type="text"
            fullWidth
            id="engineNumber"
            label="Engine Number"
            value={formik.values.engineNumber}
            onChange={formik.handleChange}
            error={
              formik.touched.engineNumber && Boolean(formik.errors.engineNumber)
            }
            helperText={
              formik.touched.engineNumber && formik.errors.engineNumber
            }
          />
          <TextField
            type="text"
            fullWidth
            id="vehicleNumber"
            label="Vehicle Number"
            value={formik.values.vehicleNumber}
            onChange={formik.handleChange}
            error={
              formik.touched.vehicleNumber &&
              Boolean(formik.errors.vehicleNumber)
            }
            helperText={
              formik.touched.vehicleNumber && formik.errors.vehicleNumber
            }
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                label="Insurance Expiry Date"
                value={formik.values.insuranceExpiryDate}
                onChange={(value) => {
                  formik.setFieldValue("insuranceExpiryDate", value);
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error:
                      formik.touched.insuranceExpiryDate &&
                      Boolean(formik.errors.insuranceExpiryDate),
                    helperText:
                      formik.touched.insuranceExpiryDate &&
                      formik.errors.insuranceExpiryDate,
                  },
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                label="Registration Date"
                value={formik.values.registrationDate}
                onChange={(value) => {
                  formik.setFieldValue("registrationDate", value);
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error:
                      formik.touched.registrationDate &&
                      Boolean(formik.errors.registrationDate),
                    helperText:
                      formik.touched.registrationDate &&
                      formik.errors.registrationDate,
                  },
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                label="Registration Expiry Date"
                value={formik.values.registrationExpiryDate}
                onChange={(value) => {
                  formik.setFieldValue("registrationExpiryDate", value);
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error:
                      formik.touched.registrationExpiryDate &&
                      Boolean(formik.errors.registrationExpiryDate),
                    helperText:
                      formik.touched.registrationExpiryDate &&
                      formik.errors.registrationExpiryDate,
                  },
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>
        <DialogActions>
          <Button
            type="submit"
            className="bg-[#3671D5] hover:bg-[#114AAA] text-white "
          >
            Continue
          </Button>
        </DialogActions>
      </form>
    </div>
  );
};

export default AddCars;
